<template>
  <el-dialog
      :visible.sync="visible"
      title="成品/配件进项发票导入"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <div class="table-bar" style="justify-content: flex-start;margin-bottom: 0px">
        <div class="bar-item">
          <UploadButton url="/erp/excel/file/receipt/product" @success="readFileSuccess"></UploadButton>
        </div>
        <FileLink file-type="front" file-url="/static/template/成品配件进项发票导入.xlsx" class="bar-item">下载模板
        </FileLink>
      </div>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500"
                  :summaries-column="['totalAmount','totalCount']" :row-style="rowStyleHandler">

        <el-table-column label="品番号" prop="product.code"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="SKU" prop="product.skuCode"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="品名" prop="product.name"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="颜色" prop="product.color"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="规格" prop="product.size"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="外销合同号" prop="orderCode" align="center">
        </el-table-column>
        <el-table-column label="出货数量" prop="totalCount"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="出货工厂"
            prop="factoryName"
            header-align="center"
            align="center" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column label="发货日期" width="120" prop="sendDate" align="center">
        </el-table-column>
        <el-table-column label="单价" prop="price"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="小计" prop="totalAmount"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="进项发票号"
            prop="receiptCode"
            header-align="center"
            align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="开票日期"
            prop="receiptDate"
            header-align="center"
            align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="开票单价"
            prop="receiptPrice"
            header-align="center"
            align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="错误提示"
            prop="errorMsg"
            header-align="center"
            align="center" :show-overflow-tooltip="true">
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="doSave" :disabled="!canSubmit">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 供应商成品发货弹窗
 */
import UploadButton from '@/components/UploadButton.vue'
import debounce from 'lodash/debounce'
import { countValidator, moneyValidator } from '@/utils/validate'
import ProductRowCard from '@/components/ProductRowCard.vue'
import moment from 'moment'
import BigNumber from 'bignumber.js'
import ImportErrorCard from '@/components/ImportErrorCard.vue'
import FileLink from '@/components/FileLink.vue'

export default {
  name: 'ProductImportDialog',
  components: { FileLink, ProductRowCard, UploadButton, ImportErrorCard },
  data () {
    return {
      visible: false,
      dataForm: {},
    }
  },
  computed: {
    dataRule () {
      return {}
    },
    canSubmit () {
      if (!this.dataForm || !this.dataForm.detailList) {
        return false
      }
      let hasError = this.dataForm.detailList.every(item => !item.errorMsg)
      return hasError
    }
  },
  methods: {
    rowStyleHandler ({ row, rowIndex }) {
      if (row.errorMsg) {
        return {
          color: 'red'
        }
      }
    },
    readFileSuccess (result) {
      if (result) {
        result.forEach(row => {
          row.totalAmount = new BigNumber(row.totalCount).multipliedBy(row.price).toFixed(3)
        })
      }
      this.dataForm.detailList = result
    },
    init (detailList) {
      this.dataForm = {
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    async doSave () {
      let postForm = []
      this.dataForm.detailList.forEach(row => {
        postForm.push({
          orderId: row.orderId,
          sourceId: row.storeLogId,
          count: row.totalCount,
          price: row.receiptPrice,
          productId: row.productId,
          receiptCode: row.receiptCode,
          receiptDate:moment(row.receiptDate).format('YYYY-MM-DD') ,
          sellerId:row.sellerId
        })
      })
      const loading = this.$loading()
      try {
        const res = await this.$api2.post('/erp/receipt/batch/save', postForm)
        this.$emit('changed')
        this.visible = false
        this.dataForm.detailList = []
      } finally {
        loading.close()
      }
    }
  },
}
</script>

